module.exports = __webpack_public_path__ + "static/media/arrow.8eb157e4.svg";